import { createAction, props } from '@ngrx/store';
import { MetadataInput } from '../models/full-record';

export const setJsonld = createAction(
  '[Jsonld] Set jsonld',
  props<{metadataInput: MetadataInput}>(),
);
